import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Tile from "./Tile";
import { getTileLayer } from "./util";

var VectorTile = /*#__PURE__*/function (_Tile) {
  _inherits(VectorTile, _Tile);

  var _super = _createSuper(VectorTile);

  function VectorTile() {
    _classCallCheck(this, VectorTile);

    return _super.apply(this, arguments);
  }

  _createClass(VectorTile, [{
    key: "initTileLayer",
    value: function () {
      var _initTileLayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var attributes, layerOptions, vectorLayer, sourceOptions, layer;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                attributes = this.parent.getLayerAttributeConfig();
                layerOptions = this.getLayerOptions();
                vectorLayer = getTileLayer(this.parent.type);
                sourceOptions = this.getSourceOption();

                if (sourceOptions) {
                  _context.next = 7;
                  break;
                }

                this.isLoaded = true;
                return _context.abrupt("return");

              case 7:
                layer = new vectorLayer(_objectSpread({}, layerOptions)).source(sourceOptions.data, sourceOptions.options); // 初始化数据映射

                Object.keys(attributes).forEach(function (type) {
                  var _attributes$attr, _attributes$attr2;

                  var attr = type; // @ts-ignore

                  layer[attr]((_attributes$attr = attributes[attr]) === null || _attributes$attr === void 0 ? void 0 : _attributes$attr.field, (_attributes$attr2 = attributes[attr]) === null || _attributes$attr2 === void 0 ? void 0 : _attributes$attr2.values);
                });
                _context.next = 11;
                return this.addLayer(layer);

              case 11:
                if (!layerOptions.tileMask) {
                  _context.next = 14;
                  break;
                }

                _context.next = 14;
                return this.addTileMask();

              case 14:
                this.setLayerMinMaxZoom(layer);
                this.isLoaded = true;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initTileLayer() {
        return _initTileLayer.apply(this, arguments);
      }

      return initTileLayer;
    }()
  }, {
    key: "getSourceOption",
    value: function getSourceOption() {
      var rawSource = this.parent.getSource();

      var _this$parent$getLayer = this.parent.getLayerConfig(),
          _this$parent$getLayer2 = _this$parent$getLayer.sourceLayer,
          sourceLayer = _this$parent$getLayer2 === void 0 ? 'defaultLayer' : _this$parent$getLayer2,
          _this$parent$getLayer3 = _this$parent$getLayer.featureId,
          featureId = _this$parent$getLayer3 === void 0 ? 'id' : _this$parent$getLayer3;

      var features = this.getFeatures(sourceLayer);
      return {
        data: {
          type: 'FeatureCollection',
          features: features
        },
        options: {
          parser: {
            type: 'geojson',
            featureId: featureId
          },
          transforms: rawSource.transforms
        }
      };
    }
  }, {
    key: "setLayerMinMaxZoom",
    value: function setLayerMinMaxZoom(layer) {
      // 文本图层设置，可见范围
      if (layer.getModelType() === 'text') {
        layer.updateLayerConfig({
          maxZoom: this.z + 1,
          minZoom: this.z - 1
        });
      }
    } // 获取瓦片数据

  }, {
    key: "getFeatures",
    value: function getFeatures(sourceLayer) {
      var source = this.sourceTile.data;
      return source.getTileData(sourceLayer);
    }
    /**
     * 在一个 Tile 中可能存在一个相同 ID 的 feature
     * @param id
     * @returns
     */

  }, {
    key: "getFeatureById",
    value: function getFeatureById(id) {
      var layer = this.getMainLayer();

      if (!layer) {
        return [];
      }

      var res = layer.getSource().data.dataArray.filter(function (d) {
        return d._id === id;
      });
      return res;
    }
  }]);

  return VectorTile;
}(Tile);

export { VectorTile as default };